import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="py-20 bg-white" data-id="element-165">
      <div className="container mx-auto px-4" data-id="element-166">
        <div className="max-w-3xl mx-auto" data-id="element-167">
          {/* Product Reveal */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-20" data-id="element-168">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-900 mb-6 font-serif" data-id="element-169">
              <span className="text-4xl md:text-6xl mr-3" data-id="element-170">📘</span>
              QUINCENA SIN ANSIEDAD
            </h2>
            <p className="text-xl md:text-2xl font-semibold text-pink-600 mb-8" data-id="element-171">
              Reset Financiero de 15 Días para Mujeres Latinas
            </p>
            <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-172">
              Un sistema práctico y emocionalmente inteligente que transforma tu
              relación con el dinero en solo 15 días.
            </p>
            <div className="bg-purple-50 rounded-xl p-6 text-left max-w-2xl mx-auto border border-purple-100" data-id="element-173">
              <p className="text-purple-900 font-medium text-lg" data-id="element-174">
                No es teoría. No es un curso complicado. No es austeridad
                extrema.
              </p>
              <p className="text-purple-900 font-bold text-xl mt-2" data-id="element-175">
                Es un reinicio real que reorganiza tu quincena desde el Día 1.
              </p>
            </div>
          </motion.div>

          {/* Origin Story */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-20" data-id="element-176">
            <h3 className="text-3xl font-bold text-purple-900 mb-8 font-serif" data-id="element-177">
              Cómo Nació Este Método
            </h3>
            <div className="space-y-4 text-lg text-gray-700" data-id="element-178">
              <p data-id="element-179">Todo empezó con una pregunta incómoda:</p>
              <blockquote className="text-xl font-semibold text-purple-800 italic border-l-4 border-pink-400 pl-4 py-2 my-6 bg-pink-50/50 rounded-r" data-id="element-180">
                “¿Cómo es posible que trabaje tanto… y nunca tenga paz
                financiera?”
              </blockquote>
              <p data-id="element-181">La creadora vivía exactamente lo mismo.</p>
              <p data-id="element-182">Ingresos estables. Trabajo constante. Cero tranquilidad.</p>
              <p data-id="element-183">
                Un mes, después de quedarse con apenas unos dólares al Día 4,
                decidió hacer algo diferente.
              </p>
              <p className="font-medium text-purple-900 mt-6" data-id="element-184">
                En vez de buscar más ingresos… decidió rediseñar los 15 días.
              </p>
              <p data-id="element-185">Se hizo una promesa:</p>
              <p className="font-bold text-pink-600 text-xl my-4 text-center" data-id="element-186">
                “No voy a ganar más este mes. Voy a organizar mejor lo que ya
                tengo.”
              </p>
              <p data-id="element-187">Probó. Ajustó. Simplificó.</p>
              <p className="font-semibold text-xl mt-6" data-id="element-188">
                La siguiente quincena no solo llegó al Día 15…
              </p>
              <p className="text-2xl font-bold text-purple-900 mb-6" data-id="element-189">
                Le sobró dinero.
              </p>
              <p data-id="element-190">Ahí entendió la verdad:</p>
              <p className="text-xl font-bold text-amber-600 bg-amber-50 inline-block px-4 py-2 rounded-lg" data-id="element-191">
                No era falta de dinero. Era falta de sistema quincenal.
              </p>
              <p className="mt-6 font-medium" data-id="element-192">
                Y así nació QUINCENA SIN ANSIEDAD.
              </p>
            </div>
          </motion.div>

          {/* The Real Problem */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#F5F0FF] rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-193">
            <h3 className="text-3xl font-bold text-purple-900 mb-6 font-serif" data-id="element-194">
              El Verdadero Problema
            </h3>
            <div className="space-y-4 text-lg text-gray-700" data-id="element-195">
              <p data-id="element-196">El problema no es tu salario.</p>
              <p data-id="element-197">No es tu disciplina.</p>
              <p data-id="element-198">No es tu carácter.</p>
              <p className="font-bold text-purple-900 mt-6 mb-4" data-id="element-199">
                Es que nadie te enseñó a manejar el flujo quincenal real de una
                mujer que:
              </p>
              <ul className="space-y-3 pl-2 mb-8" data-id="element-200">
                <li className="flex items-start gap-3" data-id="element-201">
                  <span className="text-pink-500 mt-1" data-id="element-202">✦</span>
                  <span data-id="element-203">Toma micro-decisiones todos los días.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-204">
                  <span className="text-pink-500 mt-1" data-id="element-205">✦</span>
                  <span data-id="element-206">Tiene responsabilidades familiares.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-207">
                  <span className="text-pink-500 mt-1" data-id="element-208">✦</span>
                  <span data-id="element-209">Compra pensando en todos.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-210">
                  <span className="text-pink-500 mt-1" data-id="element-211">✦</span>
                  <span data-id="element-212">Vive con carga mental constante.</span>
                </li>
              </ul>
              <p className="text-gray-500 italic" data-id="element-213">
                Los métodos tradicionales ignoran eso.
              </p>
              <p className="text-2xl font-bold text-purple-900 mt-6 text-center" data-id="element-214">
                Este sistema no.
              </p>
              <p className="text-xl font-semibold text-pink-600 text-center" data-id="element-215">
                Trabaja contigo, no contra ti.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}